// extracted by mini-css-extract-plugin
module.exports = {"title":"question_title__kJxfe","description":"question_description__3DuA7","label":"question_label__1qRwM","btnSize":"question_btnSize__102XL","attach":"question_attach__3XLDo"};